import { render, staticRenderFns } from "./BadExperience.vue?vue&type=template&id=8fb2b0cc&"
import script from "./BadExperience.vue?vue&type=script&lang=js&"
export * from "./BadExperience.vue?vue&type=script&lang=js&"
import style0 from "./BadExperience.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports